export { default as SettingEdit } from './Edit';